import React, { useState, useEffect } from 'react';
import { Col, Row, Card, Button, Modal } from 'react-bootstrap';
import DrupalFieldItem from './DrupalFieldItem';
import { CONFIG } from '../utils/config';
import moment from 'moment';
import IconClose from '../images/icon_close.png';

const CardItem = props => {
  const { viewStyle, postcodeSearch, typeTerms, hasClose } = props;
  const {
    drupal_internal__nid,
    title,
    distance,
    field_description,
    field_start_date,
    field_end_date,
    field_start_time,
    field_end_time,
    field_recurring_event,
    field_date_prefix,
    field_online_event,
    field_address,
    field_organiser,
    field_website,
    field_cost,
    field_booking_link,
  } = props.data.attributes;

  const { field_type } = props.data.relationships;

  const [logoPath, setLogoPath] = useState();
  const [eventDate, setEventDate] = useState();
  const [eventTime, setEventTime] = useState();
  const [address, setAddress] = useState(null);

  useEffect(() => {
    // set address
    if (field_online_event) {
      setAddress('Online event');
    } else if (field_address) {
      const address_line1 = field_address.address_line1
        ? `${field_address.address_line1}, `
        : '';
      const address_line2 = field_address?.address_line2
        ? field_address.address_line2 + ', '
        : '';
      const city = field_address.locality ? field_address.locality + ', ' : '';
      const postcode = field_address.postal_code ? field_address.postal_code : '';

      const addressCombined = address_line1 + address_line2 + city + postcode;
      setAddress(addressCombined);
    }

    const getLogo = async () => {
      const response = await fetch(
        `${CONFIG.API_URL}${CONFIG.EVENT_LOGO}` + '/' + drupal_internal__nid
      );
      const logo = await response.json();
      const logoUrl = `${CONFIG.API_URL}` + logo[0].thumbnail__target_id;
      if (logo) {
        setLogoPath(logoUrl);
      } else {
        setLogoPath(false);
      }
    };

    if (field_start_date && field_end_date) {
      let date = '';
      let time = '';

      const formattedStartDate = moment(field_start_date).format('D MMMM Y');
      const formattedEndDate = moment(field_end_date).format('D MMMM Y');

      if (field_start_date === field_end_date) {
        date = formattedStartDate;
      } else {
        date = `${formattedStartDate} - ${formattedEndDate}`;
      }

      if (field_date_prefix) {
        date = `${field_date_prefix} ${date}`;
      }

      if (field_start_time && field_end_time) {
        const formatSeconds = s => moment("2012-01-01").startOf('day').seconds(s).format('h:mma')

        time = `${formatSeconds(field_start_time)} - ${formatSeconds(field_end_time)}`;

        setEventTime(time);
      }

      setEventDate(date);
    }

    getLogo();
  }, [drupal_internal__nid]);

  const CostItem = props => {
    if (props.cost !== null) {
      if (props.cost === ('0.00' || '0' || 'undefined')) {
        return <DrupalFieldItem label="Cost" value='Free' />
      }
      else {
        return <DrupalFieldItem label="Cost" value={`£${props.cost}`} />
      }
    }
    else {
      return <DrupalFieldItem label="Cost" value='Free' />
    }
  };

  // terms
  const [cardTypeTerms, setCardTypeTerms] = useState([])

  const getTerms = (allTerms, field, setMethod) => {
    const cardTermIds = Array.isArray(field.data) ? field.data.map(item => item.id) : field.data.id;
    const filteredTerms = allTerms.filter(item => cardTermIds.includes(item.id));
    const filteredTermsNames = filteredTerms.map(item => item.attributes.name);

    setMethod(filteredTermsNames);
  }

  useEffect(() => {
    if (typeTerms && typeTerms.length > 0) {
      getTerms(typeTerms, field_type, setCardTypeTerms)
    }
  }, [typeTerms])


  if (viewStyle && viewStyle === 'list') {
      return (
        <div className="card list-card col-12 col-md-12 col-lg-12 m-0 my-2 p-0">
          <div className="inner h-100 p-0">

            <Row className="mx-0">
              <Col className="col-3 m-0 p-0 img-col">
                <div className="list-card-img ">
                  {logoPath && <img src={logoPath}  alt={title} className="img-fluid" />}
                </div>
              </Col>
              <Col className="col-9 content-col mx-0 px-0">
                <Row className="ml-0 mr-0">

                  <Col className="col-4">
                    <div className=" m-0 mb-2 p-2">
                      <h3 className="fw-800">{title}</h3>
                      <div>
                        {eventDate && (
                          <DrupalFieldItem label={`Date${field_recurring_event ? ' (recurring)' : ''}`}
                                           value={eventDate}/>
                        )}

                        {eventTime && (
                          <DrupalFieldItem label="Time" value={eventTime}/>
                        )}
                      </div>
                    </div>
                  </Col>

                  <Col className="col-4 pl-0">
                    <div
                      className="m-0 mb-2 p-2"
                      dangerouslySetInnerHTML={{__html: field_description.value}}
                    />
                  </Col>

                  <Col className="col-4 pl-0">
                    <div className=" m-0 mb-2 p-2">
                      <DrupalFieldItem label="Organiser" value={field_organiser}/>

                      {cardTypeTerms.length > 0 && (
                        <DrupalFieldItem label="Type" value={cardTypeTerms.join(', ')}/>
                      )}

                      <CostItem cost={field_cost}/>

                      {address && (
                        <DrupalFieldItem label="Location" value={address}/>
                      )}
                    </div>

                    {postcodeSearch && distance && (
                      <DrupalFieldItem
                        label="Distance (as the crow flies)"
                        value={`${parseFloat(distance * 0.000621371192).toFixed(1)} miles`}
                      />
                    )}
                  </Col>
                </Row>
                { (field_booking_link || field_website) && (
                  <Row className="card-footer mt-1">

                    {field_booking_link ? (
                      <Col className="col-6 p-0 m-0">
                        <Button href={field_booking_link} className="book-now-btn" target="_blank">Book now</Button>
                      </Col>
                    ) : (
                      <Col className="col-6 p-0 m-0">&nbsp;</Col>
                    )}
                    {field_website ? (
                      <Col className="col-6 p-0 m-0">
                        <Button href={field_website} className="website-btn" target="_blank">Website link</Button>
                      </Col>
                    )  : (
                      <Col className="col-6 p-0 m-0">&nbsp;</Col>
                    )}

                  </Row>
                  )}
              </Col>
            </Row>
          </div>
        </div>
      )
    } else {
      return (
        <Card className="col-12 col-md-6 col-lg-4 m-0 mb-2 p-2">
          <div className="inner h-100 p-0">
            {hasClose && (
              <div className="map-info-close" onClick={props.closeCard}><img src={IconClose} alt="close"/></div>
            )}
            <div className="card-img">
              <Card.Img variant="top" src={logoPath}/>
            </div>

            <Card.Header className="pb-0">
              <Row>
                <Col>
                  <h3 className="fw-800">{title}</h3>
                </Col>
              </Row>

              <Row>
                {eventDate && (
                  <Col>
                    <DrupalFieldItem label={`Date${field_recurring_event ? ' (recurring)' : ''}`} value={eventDate}/>
                  </Col>
                )}

                {eventTime && (
                  <Col>
                    <DrupalFieldItem label="Time" value={eventTime}/>
                  </Col>
                )}
              </Row>
            </Card.Header>
            <Card.Body className="pl-3 pt-0">
              <div
                className="content fw-400 mb-2"
                dangerouslySetInnerHTML={{__html: field_description.value}}
              />
              <div className="info row">
                <div className="col-7">
                  <DrupalFieldItem label="Organiser" value={field_organiser}/>

                  {cardTypeTerms.length > 0 && (
                    <DrupalFieldItem label="Type" value={cardTypeTerms.join(', ')}/>
                  )}

                  {address && (
                    <DrupalFieldItem label="Location" value={address}/>
                  )}
                </div>

                <div className="col-5">
                  <CostItem cost={field_cost}/>
                </div>
              </div>

              {postcodeSearch && distance && (
                <DrupalFieldItem
                  label="Distance (as the crow flies)"
                  value={`${parseFloat(distance * 0.000621371192).toFixed(1)} miles`}
                />
              )}
            </Card.Body>

            <Card.Footer className="pt-0 pb-0">
              <Row className="p-0 m-0 list-card-actions">
                {field_booking_link && (
                  <Col className="p-0 m-0">
                    <Button href={field_booking_link} className="book-now-btn" target="_blank">Book now</Button>
                  </Col>
                )}
                {field_website && (
                  <Col className="p-0">
                    <Button href={field_website} className="website-btn" target="_blank">Website link</Button>
                  </Col>
                )}
              </Row>
            </Card.Footer>
          </div>
        </Card>
      )
    }
};

export default CardItem;
